import { render } from "./ProjectDialog.vue?vue&type=template&id=4c1c8191&scoped=true"
import script from "./ProjectDialog.vue?vue&type=script&lang=js"
export * from "./ProjectDialog.vue?vue&type=script&lang=js"

import "./ProjectDialog.vue?vue&type=style&index=0&id=4c1c8191&lang=scss&scoped=true"

import exportComponent from "E:\\myProjects\\myPortfolio\\my-portfolio-vuejs\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c1c8191"]])

export default __exports__